/**
 * API service for Radiancebook EMR backend
 *
 * This file exports the generated API client services.
 * The client is auto-generated from the OpenAPI spec.
 */

// Initialize API configuration
import './apiConfig';

// Export generated services
import {
  PatientsService,
  ServicesService,
  VisitsService,
  UploadsService,
  GoalsService
} from '../generated';

// Export helper for static file URLs
export { getStaticFileUrl } from './apiConfig';

// Patient API - Wrapper to match existing interface
export const patientApi = {
  getAll: () => PatientsService.getPatientsApiPatientsGet().then(data => ({ data })),
  getById: (id) => PatientsService.getPatientApiPatientsPatientIdGet({ patientId: id }).then(data => ({ data })),
  create: (data) => PatientsService.createPatientApiPatientsPost({ requestBody: data }).then(data => ({ data })),
  update: (id, data) => PatientsService.updatePatientApiPatientsPatientIdPut({ patientId: id, requestBody: data }).then(data => ({ data })),
  delete: (id) => PatientsService.deletePatientApiPatientsPatientIdDelete({ patientId: id }).then(() => ({ data: null })),
};

// Service API - Wrapper to match existing interface
export const serviceApi = {
  getAll: (activeOnly = true) => ServicesService.getServicesApiServicesGet({ activeOnly }).then(data => ({ data })),
  getById: (id) => ServicesService.getServiceApiServicesServiceIdGet({ serviceId: id }).then(data => ({ data })),
  create: (data) => ServicesService.createServiceApiServicesPost({ requestBody: data }).then(data => ({ data })),
  update: (id, data) => ServicesService.updateServiceApiServicesServiceIdPut({ serviceId: id, requestBody: data }).then(data => ({ data })),
  delete: (id) => ServicesService.deleteServiceApiServicesServiceIdDelete({ serviceId: id }).then(() => ({ data: null })),
};

// Goals API - Wrapper to match existing interface
export const goalsApi = {
  getAll: (includeInactive = false) => GoalsService.getGoalsApiGoalsGet({ includeInactive }).then(data => ({ data })),
  getById: (id) => GoalsService.getGoalApiGoalsGoalIdGet({ goalId: id }).then(data => ({ data })),
  create: (data) => GoalsService.createGoalApiGoalsPost({ requestBody: data }).then(data => ({ data })),
  update: (id, data) => GoalsService.updateGoalApiGoalsGoalIdPut({ goalId: id, requestBody: data }).then(data => ({ data })),
  delete: (id) => GoalsService.deleteGoalApiGoalsGoalIdDelete({ goalId: id }).then(() => ({ data: null })),
};

// Visit API - Wrapper to match existing interface
export const visitApi = {
  getAll: (patientId = null) => VisitsService.getVisitsApiVisitsGet({ patientId }).then(data => ({ data })),
  getById: (id) => VisitsService.getVisitApiVisitsVisitIdGet({ visitId: id }).then(data => ({ data })),
  create: (data) => VisitsService.createVisitApiVisitsPost({ requestBody: data }).then(data => ({ data })),
  update: (id, data) => VisitsService.updateVisitApiVisitsVisitIdPut({ visitId: id, requestBody: data }).then(data => ({ data })),
  delete: (id) => VisitsService.deleteVisitApiVisitsVisitIdDelete({ visitId: id }).then(() => ({ data: null })),
};

// Upload API
export const uploadApi = {
  upload: (file) => {
    return UploadsService.uploadImageApiUploadsUploadPost({
      formData: { file }
    }).then(data => ({ data }));
  },
};

// Re-export services for direct use
export {
  PatientsService,
  ServicesService,
  GoalsService,
  VisitsService,
  UploadsService
};

// Default export for backward compatibility
const apiClient = {
  patientApi,
  serviceApi,
  goalsApi,
  visitApi,
  uploadApi,
};

export default apiClient;
